// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-radio {
  --color-checked: var(--ion-color-secondary);
  --color: var(--ion-color-secondary);
}

ion-checkbox {
  --border-color-checked: var(--ion-color-secondary);
  --background-checked: var(--ion-color-secondary);
  --border-color: var(--ion-color-secondary);
  --background: var(--background-default) ;
}

ion-item {
  --background: transparent;
  --border-width: 0px !important;
  border-bottom: 1.2px solid #857761;
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.wrapper {
  padding: 20px;
}

.privacy {
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  margin-left: 5px;
  color: var(--ion-color-primary);
}
.privacy ion-button {
  padding: 0px;
}

@media (min-width: 991px) {
  .privacy-btn {
    margin-left: 5px;
  }
}

.underline {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-up/sign-up.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACE,6BAAA;AAAF;;AAGA;EACE,QAAA;EACA,kBAAA;AAAF;;AAGA;EACE,2CAAA;EACA,mCAAA;AAAF;;AAGA;EACE,kDAAA;EACE,gDAAA;EACA,0CAAA;EACA,wCAAA;AAAJ;;AAGA;EACE,yBAAA;EACA,8BAAA;EACA,kCAAA;AAAF;;AAGA;EACE,kBAAA;EACA,yBAAA;AAAF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAEF;AADE;EACE,YAAA;AAGJ;;AC3CE;ED2CF;IAEI,gBAAA;EAGF;AACF;;AADA;EACE,+BAAA;AAIF","sourcesContent":["@use \"../../../theme/mixins\" as *;\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n\n}\nion-radio {\n  --color-checked: var(--ion-color-secondary);\n  --color: var(--ion-color-secondary);\n}\n\nion-checkbox {\n  --border-color-checked: var(--ion-color-secondary);\n    --background-checked: var(--ion-color-secondary);\n    --border-color: var(--ion-color-secondary);\n    --background: var(--background-default)\n}\n\nion-item {\n  --background: transparent;\n  --border-width: 0px !important;\n  border-bottom: 1.2px solid #857761;\n\n}\n.no-line {\n  border-bottom: 0px;\n  --background: transparent;\n}\n.wrapper{\n  padding: 20px;\n}\n.privacy{\n  font-family: Montserrat, sans-serif;\n  font-size: 14px;\n  margin-left: 5px;\n  color: var(--ion-color-primary);\n  ion-button {\n    padding: 0px;\n  }\n}\n.privacy-btn{\n  @include desktop {\n    margin-left: 5px;\n  }\n}\n.underline {\n  color: var(--ion-color-primary);\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
